import type { ReactNode } from 'react'

interface CardProps {
  title?: ReactNode
  actions?: ReactNode
  children?: ReactNode
  className?: string
}

export function DeploymentCard({ title, actions, children, className }: CardProps) {
  return (
    <div className={`deployment-card ${className ?? ''}`}>
      {(title || actions) && (
        <div className="deployment-flex deployment-between">
          {title && <div className="deployment-card-title">{title}</div>}
          {actions && <div className="deployment-flex">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  )
}

export function DeploymentError({ error }: { error: unknown }) {
  if (!error) return null
  const message = error instanceof Error
    ? error.message
    : typeof error === 'object' && error !== null && 'message' in error
      ? String((error as { message: unknown }).message)
      : String(error)
  return <div className="deployment-error-box">{message}</div>
}

export function DeploymentSpinner({ size = 14 }: { size?: number }) {
  return (
    <span
      className="deployment-spinner"
      style={{ width: size, height: size }}
      aria-label="Loading"
    />
  )
}

export function DeploymentStatusBadge({ status }: { status: string }) {
  return <span className={`deployment-badge ${classFor(status)}`}>{status}</span>
}

export function DeploymentJsonView({ data }: { data: unknown }) {
  if (data === null || data === undefined) {
    return <span className="deployment-muted">-</span>
  }
  return <pre className="deployment-json-view">{JSON.stringify(data, null, 2)}</pre>
}

function classFor(status: string): string {
  switch (status) {
    case 'succeeded':
    case 'approved':
    case 'target_promoted':
      return 'ok'
    case 'failed':
    case 'release_register_failed':
    case 'comparison_failed':
    case 'rejected':
      return 'bad'
    case 'queued':
    case 'running':
      return 'warn'
    default:
      return 'muted'
  }
}
